export namespace BREAKPOINTS {
  export const xl = '120rem'; // 1920px
  export const lg = '80rem'; // 1280px
  export const md = '60rem'; // 960px
  export const sm = '45rem'; // 720px
  export const xs = '37.5rem'; // 600px
}
